import { render } from "./expertProfile.vue?vue&type=template&id=5541897e&scoped=true&ts=true"
import script from "./expertProfile.vue?vue&type=script&lang=ts"
export * from "./expertProfile.vue?vue&type=script&lang=ts"

import "./expertProfile.vue?vue&type=style&index=0&id=5541897e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5541897e"]])

export default __exports__